import { useEffect, useState } from "react";
import { Instagram } from "lucide-react";
import { PORTFOLIO } from "../data/content";

const IG_URL = "https://www.instagram.com/the.krstudio/";
const FALLBACK = PORTFOLIO.slice(0, 14).map((it) => ({
  id: it.src,
  image_url: it.src,
  permalink: IG_URL,
  caption: it.alt,
}));

export const InstaStrip = () => {
  const [items, setItems] = useState(FALLBACK);
  const [live, setLive] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/instagram/feed?limit=14`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((x) => {
        if (x.data?.length) {
          setItems(x.data);
          setLive(true);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <section className="insta-strip" data-testid="insta-strip">
      <div className="wrap insta-head">
        <a href={IG_URL} target="_blank" rel="noopener noreferrer" className="insta-handle" data-testid="insta-handle-link">
          <Instagram size={18} /> @the.krstudio
        </a>
        <p>{live ? "Our latest posts — straight from Instagram." : "Fresh work, behind-the-scenes and campaigns — follow us on Instagram."}</p>
      </div>
      <div className="insta-marquee" data-testid="insta-marquee">
        <div className="insta-track">
          {[0, 1].map((copy) => (
            <div className="insta-copy" key={copy} aria-hidden={copy === 1 ? "true" : undefined}>
              {items.map((it, i) => (
                <a
                  href={it.permalink || IG_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="insta-card"
                  key={`${it.id}-${i}`}
                  aria-label={`${it.caption || "Instagram post"} — view on Instagram`}
                  data-testid={copy === 0 && i === 0 ? "insta-card-first" : undefined}
                >
                  <img src={it.image_url} alt={it.caption || "Instagram post"} loading="lazy" />
                  <span className="insta-card-overlay"><Instagram size={20} /></span>
                </a>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
